import { Fragment } from "react";

function CpaFailedAccept({ resetAcceptFiling }) {
  return (
    <Fragment>
      <h3 style={{ textAlign: "center" }}>Ups, sorry</h3>
      <br></br>
      <hr></hr>
      <br></br>
      <div className="blueRect centered">
        <button className="btn btnBox btnWhite" onClick={resetAcceptFiling}>
          <b>Close</b>
        </button>
      </div>
    </Fragment>
  );
}

export default CpaFailedAccept;
